import 'ress';

import 'typeface-lato';
import 'typeface-montserrat';

import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  :root, body {
    font-family: "Roboto Condensed", sans-serif;
    font-size: 1em;
    /* line-height: 1rem; */
    text-rendering: geometricPrecision;
    overflow: hidden;

    @media all and (max-width: 400px) {
      font-size: 14px;
    }

    @media all and (max-width: 320px) {
      font-size: 12px;
    }
  }

  body, #root {
    height: 100vh;
    max-width: 100vw;
  }

  button {
    -webkit-appearance: none;
    border-width: 0;
    border-color: transparent;
  }

  button:focus {
    outline: none;
  }

  html {
    overflow-y: initial;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  a.visited {
    text-decoration: none;
  }

  svg {
    display: inline-block;
    overflow: visible;
  }
  input[type="text"]:disabled {
    color: gray;
  }

  .react-resizable {
    position: absolute !important;
  }

  .react-resizable > .react-resizable-handle {
    visibility: hidden;
  }
  .react-resizable:hover > .react-resizable-handle {
    visibility: visible;
  }

  .react-resizable-handle {
    // background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiNmZmZmZmYiLz48L2c+PC9zdmc+') !important;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KIDxnPg0KICA8ZyBpZD0ic3ZnXzEiIG9wYWNpdHk9IjEiPg0KICAgPHBhdGggaWQ9InN2Z18yIiBmaWxsPSIjZmZmZmZmIiBkPSJtNiw2bC02LDBsMCwtMS44bDQsMGwwLjIsMGwwLC00LjJsMS44LDBsMCw2bDAsMHoiLz4NCiAgPC9nPg0KIDwvZz4NCjwvc3ZnPg==") !important;
    opacity:0.5 !important;
  }
  .react-resizable-handle-e {
    z-index: 10;
  }
`;
